import { FinancialGraphData } from './financials.entities' 
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../shared/scripts/table-column-visibility";
import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";

var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/drilldown')(Highcharts);

export class FinancialCharts {

    expendituresChart: any;
    lastInvoiceDateChart: any;
    performedDrilldown: boolean;
    chartCategories: string[];

    tableId: string = "subcontract-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    dataTable: any;
    tableColumnController: TableColumnVisibilityController;
    allSubcontracts: FinancialGraphData[];
    currentSubcontracts: FinancialGraphData[];

    containerId: string = "#financial-summary-by-study";
    constructor() {
        Highcharts.setOptions({
            lang: {
                drillUpText: '◁ Back',
                thousandsSep: ','
            }
        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            //to setup dropdowns to go downwards
            if (e.currentTarget.id == "summary-tab") {
                ['#subcontract-table-column-filter-dropdown', '#subcontract-vendor-table-column-filter-dropdown'].forEach((id: string) => $(id).selectpicker("refresh"));
            }
        });


        this.performedDrilldown = false;
    }

    setGraphContent(graphData: FinancialGraphData[]): void {
        this.setExpendituresChart(graphData);
        this.setLastInvoiceDateChart(graphData);

        this.chartCategories = [];
        graphData.forEach((study) => this.chartCategories.push(study.Name));

        this.allSubcontracts = graphData;
        this.currentSubcontracts = graphData;
        this.setSubcontractDataTable(graphData);
    }

    private setExpendituresChart(graphData: FinancialGraphData[]): void {

        $(this.containerId).find('#project-expenditure-graph').empty();
        $(this.containerId).find('#project-expenditure-graph').height(this.getChartHeight(graphData.length));

        let series = this.getExpenditureSeries(graphData);

        this.expendituresChart = Highcharts.chart('project-expenditure-graph', {
            chart: {
                type: 'bar',
                events: {
                    drilldown: (e) => {
                        $(this.containerId).find('#project-expenditure-graph').height(this.getChartHeight(e.seriesOptions.data.length));
                        let clickedCategory: string = e.seriesOptions.id.substring(0, e.seriesOptions.id.indexOf("-")).trim();
                        //this.expendituresChart.setTitle(null, { text: 'Category: ' + clickedCategory });
                        let undoButton: string = `<button class='btn btn-outline-secondary chart-drillup-btn mr-2'><i class="fas fa-undo"></i></button>`
                        this.expendituresChart.setTitle({ text: `${undoButton} Displaying vendors for: ${clickedCategory}` }, null);

                        if (!this.performedDrilldown) {

                            this.performedDrilldown = true;
                            let point: any = this.lastInvoiceDateChart.get('days-since-last-invoice-series').points.find((pt: any) => pt.name == clickedCategory);
                            if (point) {
                                point.doDrilldown(false);
                            }         
                            this.drilldownTable(clickedCategory);
                        }

                        this.expendituresChart.reflow();
                        this.expendituresChart.redraw();

                        $(this.containerId).find(".chart-drillup-btn").on('click', () => {
                            this.drillupTable();
                        });
                        //this.fadeLabels("#project-expenditure-graph");                                            
                    },
                    drillup: (e) => {
                        $(this.containerId).find('#project-expenditure-graph').height(this.getChartHeight(e.seriesOptions.data.length));
                        //this.expendituresChart.setTitle(null, { text: 'Click a category to learn more' });
                        this.expendituresChart.setTitle({ text: 'Click a category to learn more' }, null);

                        if (this.performedDrilldown) {
                            this.performedDrilldown = false;
                            this.lastInvoiceDateChart.drillUp();
                        }
                        this.expendituresChart.reflow();
                        this.expendituresChart.redraw();

                        //this.fadeLabels("#project-expenditure-graph");
                    }
                },
                zoomType: 'y',
                panning: true,
                marginTop: 70
            },
            credits: { enabled: false },
            //title: { text: null },
            //subtitle: { text: 'Click a category to learn more', align: 'left', style: {color: 'black'} },
            title: { text: 'Click a category to learn more', align: 'left', margin: 0, style: { color: 'black', fontSize: '14px' }, useHTML: true },
            tooltip: {
                valuePrefix: '$',
                valueDecimals: 2
                //pointFormat: "$ {point.y:,.2f}"
            },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                //reversedStacks: false,
                title: { text: '' },
                labels: {
                    formatter: function () {
                        if (this.value >= 100000) {
                            return '$' + (this.value / 1000000) + 'M'
                        }
                        else {
                            return '$' + this.value
                        }
                        
                    }
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        if (this.total >= 100000) {
                            let millionsVal = (this.total / 1000000);
                            let styledVal = Highcharts.numberFormat(millionsVal, 2, '.', ',');
                            return "$" + styledVal + 'M'
                        }
                        else {
                            let styledVal = Highcharts.numberFormat(this.total, 0, '.', ',');
                            return "$" + styledVal
                        }

                    },
                    inside: false, //label issues
                    //crop: false,
                    //overflow: 'none'
                }
            },
            legend: { reversed: true, verticalAlign: 'top' },
            plotOptions: {
                series: { stacking: 'normal' },
                bar: { borderWidth: 0 }
            },
            series: series.primarySeries,
            drilldown: {
                drillUpButton: {
                    position: {
                        align: 'left',
                        y: -40,
                        x: -40
                    },
                    theme: {
                        display: 'none'
                    }
                },
                series: series.drillDownSeries
            }
        });
    }

    private setLastInvoiceDateChart(graphData: FinancialGraphData[]): void {

        $(this.containerId).find('#days-since-last-invoice-graph').empty();
        $(this.containerId).find('#days-since-last-invoice-graph').height(this.getChartHeight(graphData.length));

        let series = this.getLastInvoiceDateSeries(graphData);

        this.lastInvoiceDateChart = Highcharts.chart('days-since-last-invoice-graph', {
            chart: {
                type: 'bar',
                events: {
                    drilldown: (e) => {
                        $(this.containerId).find('#days-since-last-invoice-graph').height(this.getChartHeight(e.seriesOptions.data.length));
                        let clickedCategory: string = e.seriesOptions.id.substring(0, e.seriesOptions.id.indexOf("-")).trim();                   
                        //this.lastInvoiceDateChart.setTitle(null, { text: 'Category: ' + clickedCategory });

                        if (!this.performedDrilldown) {
                            this.performedDrilldown = true;
                            //this.expendituresChart.xAxis[0].drilldownCategory(e.category);

                            let clickedIndex = this.chartCategories.findIndex((category) => category == clickedCategory);
                            if (clickedIndex != -1) {
                                this.expendituresChart.xAxis[0].drilldownCategory(clickedIndex);
                                this.drilldownTable(clickedCategory);
                            }
                        }

                        this.fadeLabels("#days-since-last-invoice-graph");
                        this.fadeLabels("#project-expenditure-graph");
                        this.lastInvoiceDateChart.reflow();
                    },
                    drillup: (e) => {
                        $(this.containerId).find('#days-since-last-invoice-graph').height(this.getChartHeight(e.seriesOptions.data.length));
                        //this.lastInvoiceDateChart.setTitle(null, { text: 'Click a category to learn more' });

                        if (this.performedDrilldown) {
                            this.performedDrilldown = false;
                            this.expendituresChart.drillUp();
                        }

                        this.fadeLabels("#days-since-last-invoice-graph");
                        this.fadeLabels("#project-expenditure-graph");
                        this.lastInvoiceDateChart.reflow();
                    }
                },
                zoomType: 'y',
                panning: true,
                marginTop: 70
            },

            credits: { enabled: false },
            title: { text: '-', align: 'left', margin: 0, style: { color: 'transparent', fontSize: '14px' }, useHTML: true },
            //subtitle: { text: 'Click a category to learn more', align: 'left' },
            xAxis: {
                type: 'category'
            },
            yAxis: {
                min: 0,
                endOnTick: false, // helps with cropping data labels
                maxPadding: 0.2, // larger value has more space for data labels (default is 0.05)
                //reversedStacks: false,
                title: { text: '' },
                labels: {
                    //formatter: function () {
                    //    //return '$' + this.axis.defaultLabelFormatter.call(this);
                    //    return '$' + (this.value / 1000000) + 'M'
                    //}
                },
                stackLabels: {
                    enabled: true,
                    formatter: function () {
                        return Highcharts.numberFormat(this.total, 0, '.', ',');              
                    },
                    inside: false, //label issues
                    //crop: false,
                    //overflow: 'none'
                }
            },
            legend: { reversed: true, verticalAlign: 'top' },
            plotOptions: {
                series: { stacking: 'normal' },
                bar: { borderWidth: 0 }
            },
            series: series.primarySeries,
            drilldown: {
                drillUpButton: {
                    position: {
                        y: -40
                    },
                    theme: {
                        display: 'none'
                    }
                },
                series: series.drilldownSeries
            }
        });
    }


    private setSubcontractDataTable(data: FinancialGraphData[]): void {

        let chart = this;
        let columns: any[] = [
            { data: { _: "Id", display: "StudyNameDisplay" }, title: "Category", className: "sub-category text-left font-size12 nowrap", orderable: false },
            { data: { _: "Name", display: "VendorNameDisplay" }, title: "Vendor", className: "sub-vendor text-left font-size12 nowrap" },
            { data: "SubcontractNumber", title: "Subcontract #", className: "sub-number text-left font-size12 nowrap" },
            { data: "POID", title: "PO/Vendor<br/>ID", className: "sub-poid text-center font-size12 nowrap" },
            { data: "ProjectLevel", title: "Project<br/>Code", className: "sub-project-code text-center font-size12 nowrap" },
            { data: { _: "SubcontractStartDateCompare", display: "SubcontractStartDate" }, title: "Subcontract<br/>Start Date", className: "sub-subcontract-start-date text-center font-size12 nowrap" },
            { data: { _: "SubcontractEndDateCompare", display: "SubcontractEndDate" }, title: "Subcontract<br/>End Date", className: "sub-subcontract-end-date text-center font-size12 nowrap" },
            { data: "SubcontractType", title: "Subcontract<br/>Type", className: "sub-subcontract-type text-center font-size12 nowrap" },

            { data: { _: "TotalSubcontractAmount", display: "TotalSubcontractAmountDisplay" }, title: "Total<br/>Subcontract<br/>Amount", className: "sub-subcontract-amount text-center font-size12 nowrap" },
            { data: { _: "TotalRestrictedFunds", display: "TotalRestrictedFundsDisplay" }, title: "Total<br/>Restricted<br/>Funds", className: "sub-restricted-funds text-center font-size12 nowrap" },
            { data: { _: "TotalUnrestrictedFunds", display: "TotalUnrestrictedFundsDisplay" }, title: "Total<br/>Unrestricted<br/>Funds", className: "sub-unrestricted-funds text-center font-size12 nowrap" },
            { data: { _: "RemainingUnrestrictedFunds", display: "RemainingUnrestrictedFundsDisplay" }, title: "Remaining<br/>Unrestricted<br/>Funds", className: "sub-remaining-unrestricted text-center font-size12 nowrap" },

            { data: { _: "TotalInvoicedToDate", display: "TotalInvoicedToDateDisplay" }, title: "Total<br/>Invoiced<br/>To Date", className: "sub-invoiced-to-date text-center font-size12 nowrap" },
            { data: { _: "LastInvoiceDateCompare", display: "LastInvoiceDate" }, title: "Last<br/>Invoice<br/>Date", className: "sub-last-invoice-date text-center font-size12 nowrap" },
            //{ data: "StudyName", title: "Study Name", visble: false, className: "d-none" }
        ];

        let tableColumnGroups: TableColumnGroup[] = [

            //new TableColumnGroup("Category", true, [], "sub-category"),
            new TableColumnGroup("Vendor", false, [], "sub-vendor"), // auto show on drilldown
            new TableColumnGroup("Subcontract #", false, [], "sub-number"),
            new TableColumnGroup("PO/Vendor ID", false, [], "sub-poid"),
            new TableColumnGroup("Project Code", false, [], "sub-project-code"),
            new TableColumnGroup("Subcontract Start Date", false, [], "sub-subcontract-start-date"),
            new TableColumnGroup("Subcontract End Date", false, [], "sub-subcontract-end-date"), // auto show on drilldown
            new TableColumnGroup("Subcontract Type", false, [], "sub-subcontract-type"), // auto show on drilldown

            new TableColumnGroup("Total Subcontract Amount", true, [], "sub-subcontract-amount"),
            new TableColumnGroup("Total Restricted Funds", true, [], "sub-restricted-funds"),
            new TableColumnGroup("Total Unrestricted Funds", true, [], "sub-unrestricted-funds"),
            new TableColumnGroup("Remaining Unrestricted Funds", true, [], "sub-remaining-unrestricted"),
            new TableColumnGroup("Total Invoiced to Date", true, [], "sub-invoiced-to-date"),
            new TableColumnGroup("Last Invoice Date", true, [], "sub-last-invoice-date")
        ];

        this.dataTable = $('#' + this.tableId).DataTable({
            "dom": '<"top-controls"<"column-select"><"added-since"><"search-bar"f><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: true,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            /*fixedColumns: {
                leftColumns: 1
            },*/
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Financials Export"
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                },
                {
                    extend: 'csv',
                    text: '<span class="font-size12 dt-text-btn">Export All</span>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Financials Export All",
                    customize: function (csv) {
                        let allExportItems = [];
                        chart.allSubcontracts.map(item => {
                            item.VendorNameDisplay = "TOTAL"
                            allExportItems.push(item);
                            item.DrillDown.map(drillDownItem => {
                                allExportItems.push(drillDownItem);
                            })
                        });
                        let modifiedCSV = chart.convertToCSV(allExportItems);
                        return modifiedCSV;
                    }
                }
            ],
            order: [0, 'asc'],
            data: this.allSubcontracts,
            initComplete: (settings, json) => {
                // Set up Drillup Button
                $(this.containerId).find("th.sub-category").html(`
                    <div>
                        <div class='mb-2 d-none table-drillup-container'>
                            <button class='btn btn-outline-secondary table-drillup-btn'><i class="fas fa-undo"></i></button>
                        </div>
                        <div>Category</div>
                    </div>
                `);

                $(this.containerId).find(".table-drillup-btn").on('click', () => {
                    this.drillupTable();
                });

                // Set up Drilldown
                let charts = this;
                $(this.containerId).find(".table-drilldown-btn").on('click', function () {
                    // Drilldown the charts
                    let clickedCategory = $(this).text();
                    let clickedIndex = charts.chartCategories.findIndex((category) => category == clickedCategory);
                    charts.expendituresChart.xAxis[0].drilldownCategory(clickedIndex);

                    // Update the Table
                    charts.drilldownTable(clickedCategory);
                });
            }
        });

        $("#" + this.tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + this.tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + this.tableWrapperId + " .column-select").empty().html('<div id="' + this.tableId + '-column-select"></div>');

        $("#" + this.tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + this.tableWrapperId + " .spacer").addClass('col-12 col-md-1');
        $("#" + this.tableWrapperId + " .count-found").addClass('col-12 col-md-5 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + this.tableId + '-found-count\"></span></div>');
        $("#" + this.tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(this.tableId, (this.tableId + '-column-select'), tableColumnGroups);

        $('#' + this.tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(this.dataTable.rows({ search: 'applied' }).count());
        });

        $("#" + this.tableWrapperId).find("th.sorting").on('click', () => {
            this.dataTable.columns.adjust().draw();
        })
            
        this.setCountFoundLabel(this.allSubcontracts.length);

        //this.initializeTableLinks();
        this.dataTable.on('draw', (e, settings) => {
            this.initializeTableLinks();
        });

        $("#summary-tab").on('click', () => {
            setTimeout(() => {
                this.dataTable.columns.adjust().draw();
            }, 500)
        }); 

        $("#summary-chart-switch").on('change', () => {
            setTimeout(() => {
                this.dataTable.columns.adjust().draw();
            }, 250)
        });
    }

    private setCountFoundLabel(count: number): void {

        switch (count) {
            case 0: $('#' + this.tableId + '-found-count').text("No Entries Found"); break;
            case 1: $('#' + this.tableId + '-found-count').text("1 Entry Found"); break;
            default: $('#' + this.tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Entries Found");
        }
    }

    private initializeTableLinks() {
        let charts = this;

        $(this.containerId).find(".table-drilldown-btn").off('click');
        $(this.containerId).find(".table-drilldown-btn").on('click', function() {
            // Drilldown the charts
            let clickedCategory = $(this).text();
            let clickedIndex = charts.chartCategories.findIndex((category) => category == clickedCategory);
            charts.expendituresChart.xAxis[0].drilldownCategory(clickedIndex);
        });
    }

    private drilldownTable(category: string): void {
        $(this.containerId).find(".table-drillup-container").removeClass("d-none");
        let subcontracts = this.allSubcontracts.find(subcontract => subcontract.StudyName == category).DrillDown;
        if (!subcontracts) {
            return
        }
        this.currentSubcontracts = subcontracts;

        // Gives you selected column Names
        let selectedColumnNames: string[] = <string[]>$(`#${this.tableId}-column-filter-dropdown`).val(); 

        // Gives you all the names of the datatable
        let columnHeaders = this.dataTable.columns().header().toArray();
        let allColumnNames = [];
        columnHeaders.forEach(header => {
            let columnName = $(header).html().replace("<br>", " ").replace("<br>", " ").trim();
            allColumnNames.push(columnName);
        });

        // Get Selected Column Indexes
        let selectedColumnIndexes = [1,6,7] // Defaults
        for (let i = 0; i < allColumnNames.length; i++) 
        {
            if (selectedColumnNames.indexOf(allColumnNames[i]) != -1 && selectedColumnIndexes.indexOf(i) == -1) {
                selectedColumnIndexes.push(i);
            }
        }

        // Show columns for drilldown 
        this.dataTable.columns(selectedColumnIndexes).visible(true, false);
       

        this.updateTableContent(this.currentSubcontracts);
        this.clearSearchBar();
    }

    private drillupTable(): void {
        // Drilldown the charts
        $(this.containerId).find(".table-drillup-container").addClass("d-none");
        this.expendituresChart.drillUp();

        // Hide unused columns for top level
        this.dataTable.columns([1, 2, 3, 4, 5, 6, 7]).visible(false, false); // Blank for top level

        // Update the Tables
        this.updateTableContent(this.allSubcontracts);
        this.clearSearchBar();
    }

    private updateTableContent(subcontracts: FinancialGraphData[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(subcontracts);
        this.dataTable.order([0, 'asc']).draw();

        this.setCountFoundLabel(subcontracts.length);

        setTimeout(() => {
            //this.dataTable.order([0, 'asc']);
            this.dataTable.columns.adjust().draw();
        }, 250)
        
    }


    private getChartHeight(entries: number): number {
        let value: number = 150 + (entries * 30 * 1.5);
        return value;
    }



    private getExpenditureSeries(data: FinancialGraphData[]) {
        let dataLabels: string[] = ['Committed Restricted', 'Remaining Unrestricted', 'Invoiced To-Date']; // Readable Data Labels
        let dataLabelIds: string[] = ['reserved-series', 'unreserved-series', 'invoiced-series']; // Data Label IDs
        let dataFields: string[] = ['CommittedRestricted', 'RemainingUnrestricted', 'InvoicedToDate']; // FinanacialGraphData fields mapped to Data Labels
        let seriesColors: string[] = ['#6e6e6e', '#77a6b6 ', '#E9C46A ']; // Colors for each data label

        let drillDownSeries = [];
        let primarySeries = dataLabels.map((label: string, index: number) => {
            let primaryData: any[] = [];
            data.forEach((study: FinancialGraphData) => {

                primaryData.push({ 
                    name: study.Name, // Study Name
                    y: study[dataFields[index]], // Amount of Money (per category)
                    drilldown: study.Name + "-" + label // id of relative drilldown
                });

                let filteredRecords: FinancialGraphData[] = study.DrillDown; // Get vendors and other folks assoicated with study
                let detailedDrilldownData: any[] = [];
                filteredRecords.forEach((record: FinancialGraphData) => {
                    detailedDrilldownData.push(
                        [record.Name, record[dataFields[index]]] // [Vendor Name, Amount of Money (per category)]
                    );
                });

                drillDownSeries.push({
                    name: label, // Data Label
                    id: study.Name + "-" + label, // id to help drilldown
                    data: detailedDrilldownData // [Vendor Name, Amount of Money]
                });
            });

            return {
                id: dataLabelIds[index],
                name: label,
                data: primaryData,
                //drilldown: label,
                color: seriesColors[index],
            };
        });

        return {
            primarySeries: primarySeries,
            drillDownSeries: drillDownSeries
        };
    }

    private getLastInvoiceDateSeries(graphData: FinancialGraphData[]) {
        let drilldownLastInvoicedSeries: any[] = [];
        let invoiceData: any[] = graphData.map((study: FinancialGraphData) => {

            let filteredRecords = study.DrillDown;
            let detailedDrilldownData: any[] = [];
            filteredRecords.forEach((record: FinancialGraphData) => {
                detailedDrilldownData.push(
                    [record.Name, record.DaysSinceLastInvoice]
                );
            });

            drilldownLastInvoicedSeries.push({
                name: "Days Since Last Invoice",
                id: study.Name + "-",
                data: detailedDrilldownData
            });

            return {
                name: study.Name,
                y: study.DaysSinceLastInvoice,
                drilldown: study.Name + "-"
            };
        });

        let primarySeries = [{
            id: 'days-since-last-invoice-series',
            name: "Days Since Last Invoice",
            data: invoiceData,
            //color: "#152850",
            color: "#E9C46A"
        }];

        return {
            primarySeries: primarySeries,
            drilldownSeries: drilldownLastInvoicedSeries 
        }
    }

    private fadeLabels(chartId: string): void {
        let stackLabel = $(chartId).find('.highcharts-stack-labels').first();
        stackLabel.addClass("d-none");
        stackLabel.removeClass("show-label");
        setTimeout(() => {
            stackLabel.addClass("show-label");
            stackLabel.removeClass("d-none");
            this.hideExcessLabels(chartId);
        }, 20);
        
    }

    private hideExcessLabels(chartId: string): void {
        let stackLabels = $(chartId).find('.highcharts-stack-labels').children('.highcharts-label');
        let isHidden = false;
        if (stackLabels.length > 0) {
            if (stackLabels[0].getAttribute('visibility') == 'hidden') {
                return;
            }
        }
        for (let i = 0; i < stackLabels.length; i++) {
            // if the label is hidden
            if (stackLabels[i].getAttribute('visibility') == 'hidden') {
                isHidden = true;
            }

            if (isHidden && stackLabels[i].getAttribute('visibility') == 'visible') {
                //console.log("Hide This:")
                //console.log(stackLabels[i]);
                stackLabels[i].setAttribute('visibility', 'hidden');
            }
        }      
    }

    private convertToCSV(objArray: FinancialGraphData[]): string {
        let csvArray = [
            [
                "\"Category\"",
                "\"Vendor\"",
                "\"Subcontract #\"",
                "\"PO/Vendor ID\"",
                "\"Project Code\"",
                "\"Subcontract Start Date\"",
                "\"Subcontract End Date\"",
                "\"Subcontract Type\"",
                "\"Total Subcontract Amount\"",
                "\"Total Restricted Funds\"",
                "\"Total Unrestricted Funds\"",
                "\"Remaining Unrestricted Funds\"",
                "\"Total Invoiced To Date\"",
                "\"Last Invoice Date\""
            ],
         
            ...objArray.map(item => [
                `\"${item.StudyName}\"`,
                `\"${item.VendorNameDisplay}\"`,
                `\"${item.SubcontractNumber}\"`,
                `\"${item.POID}\"`,
                `\"${item.ProjectLevel}\"`,
                `\"${item.SubcontractStartDate}\"`,
                `\"${item.SubcontractEndDate}\"`,
                `\"${item.SubcontractType}\"`,
                `\"${item.TotalSubcontractAmountDisplay}\"`,
                `\"${item.TotalRestrictedFundsDisplay}\"`,
                `\"${item.TotalUnrestrictedFundsDisplay}\"`,
                `\"${item.RemainingUnrestrictedFundsDisplay}\"`,
                `\"${item.TotalInvoicedToDateDisplay}\"`,
                `\"${item.LastInvoiceDate}\"`
            ])
          
        ];
        let csvJoined = csvArray.map(item => item.join(","));
        let csvString = csvJoined.join("\n");
   
        return csvString;
    }

    clearSearchBar(): void {
        this.dataTable.search('').draw();
    }

}